import { render, staticRenderFns } from "./gsxw.vue?vue&type=template&id=4a5492ba&scoped=true"
import script from "./gsxw.vue?vue&type=script&lang=js"
export * from "./gsxw.vue?vue&type=script&lang=js"
import style0 from "./gsxw.vue?vue&type=style&index=0&id=4a5492ba&prod&scoped=true&lang=css"
import style1 from "./gsxw.vue?vue&type=style&index=1&id=4a5492ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5492ba",
  null
  
)

export default component.exports